import { sharedWearablesColumns } from "./sharedWearablesColumns"
import { InputCellRenderer } from "@/components/shared/Table/TextCellRenderer"
import { Column } from "@/components/shared/Table/types"
import { WearableSensor } from "@/types/wearableSensors"
import { formatInmateName } from "@/utils/index"

export const wearablesColumns: Column<WearableSensor>[] = [
   ...sharedWearablesColumns,
   {
      key: "inmate",
      label: "Inmate",
      sortable: true,
      renderCell: (args) =>
         InputCellRenderer<WearableSensor>({
            field: "inmate",
         })({
            ...args,
            value:
               args.row.inmate?.customIdentifier ||
               formatInmateName(args.row.inmate),
         }),
   },
]
